import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Titre from "../Components/common/Titre";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";

export default function Engagement() {
  return (
    <Container className="px-4 bg-transparent">
      <Titre
        icon={faGraduationCap}
        children={"POURQUOI ETUDIER CHEZ NOUS ?"}
        soustitre={
          "Chez FCIS, nous nous engageons à offrir une formation de qualité, à accompagner nos étudiants vers l'excellence et à contribuer activement à la société à travers nos projets et recherches innovants."
        }
      />

      <Row className="gy-4">
        {[
          { 
            titre: "FLEXIBILITÉ", 
            texte: "Avec  PECI, il n’est jamais trop tard pour commencer à étudier. SANS LIMITE D'ÂGE . Vous pouvez commencer à n’importe quel niveau à partir de la classe de 6eme, 5eme, 4eme, 3eme, 2nd, 1ière, Tle et prépa-université." 
          },
          { 
            titre: "Obtention d'un diplôme international", 
            texte: "Obtenez un diplôme reconnu dans toutes les universités du monde, garantissant des possibilités d'inscription dans les meilleures institutions." 
          },
          { 
            titre: "Inscription garantie", 
            texte: "Nous vous assurons une inscription dans les grandes universités et vous accompagnons tout au long du processus." 
          },
          { 
            titre: "Service d'orientation et de visas agréé", 
            texte: "Bénéficiez de services d'orientation personnalisés et d'aide dans vos démarches de visa pour étudier à l'international." 
          },
          { 
            titre: "Etudier à distance ou en présentiel", 
            texte: "Étudiez selon votre convenance, que ce soit en ligne ou en présentiel, pour une flexibilité maximale." 
          },
          { 
            titre: "Bourses d'études garanties", 
            texte: "Profitez de bourses d’études dans certaines universités au Canada et aux USA pour alléger vos frais de scolarité." 
          },
          { 
            titre: "Diplôme secondaire pour employé(e)s et employeurs", 
            texte: "Si vous êtes employé(e) ou employeur sans baccalauréat, décrochez votre diplôme d'études secondaires de l'Ontario en 6 mois, en ligne et à domicile, pour devenir éligible à la demande de résidence permanente." 
          },
        ].map((item, index) => (
          <Col md={4} key={index}>
            <Card className="h-100 shadow border-0 rounded-3">
              <Card.Title className="text-white mt-3 p-3 fw-bold mb-3 mr-3 bg-b">
                {item.titre}
              </Card.Title>
              <Card.Body>
                <Card.Text className="text-muted">
                  {item.texte}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
